
import './index.css';

import * as React from 'react';
import {createRoot} from 'react-dom/client';
import { store } from './store/index';

import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import App from './App.jsx';


// Handle runtime errors
const showErrorOverlay = (err) => {
    const ErrorOverlay = customElements.get('vite-error-overlay');
    if (!ErrorOverlay) {
        return;
    }
    console.log(err)
    const overlay = new ErrorOverlay(err);
    const body = document.body;
    if (body !== null) {
        body.appendChild(overlay);
    }
};

window.addEventListener('error', showErrorOverlay);
window.addEventListener('unhandledrejection', ({reason}) =>
  showErrorOverlay(reason),
);

createRoot(document.getElementById('root')).render(
  <Provider store={store}>
      <BrowserRouter>
          <App />
      </BrowserRouter>
  </Provider>
);
